enum iaqRealtimeViewDataType {
  GET_IAQ_REALTIME_VIEW_DATA_START = "GET_IAQ_REALTIME_VIEW_DATA_START",
  GET_IAQ_REALTIME_VIEW_DATA_SUCCESS = "GET_IAQ_REALTIME_VIEW_DATA_SUCCESS",
  GET_IAQ_REALTIME_VIEW_DATA_ERROR = "GET_IAQ_REALTIME_VIEW_DATA_ERROR",
  GET_IAQ_REALTIME_VIEW_CHART_DATA_START = "GET_IAQ_REALTIME_VIEW_CHART_DATA_START",
  GET_IAQ_REALTIME_VIEW_CHART_DATA_SUCCESS = "GET_IAQ_REALTIME_VIEW_CHART_DATA_SUCCESS",
  GET_IAQ_REALTIME_VIEW_CHART_DATA_ERROR = "GET_IAQ_REALTIME_VIEW_CHART_DATA_ERROR",
  RESET_IAQ_REALTIME_VIEW_CHART_DATA = "RESET_IAQ_REALTIME_VIEW_CHART_DATA",
  RESET_IAQ_REALTIME_VIEW_DATA = "RESET_IAQ_REALTIME_VIEW_DATA",

  // GET_IAQ_THRESHOLD_BY_ICCID = "GET_IAQ_THRESHOLD_BY_ICCID",
  GET_IAQ_THRESHOLD_BY_ICCID_START = "GET_IAQ_THRESHOLD_BY_ICCID_START",
  GET_IAQ_THRESHOLD_BY_ICCID_SUCCESS = "GET_IAQ_THRESHOLD_BY_ICCID_SUCCESS",
  GET_IAQ_THRESHOLD_BY_ICCID_ERROR = "GET_IAQ_THRESHOLD_BY_ICCID_ERROR",
  RESET_IAQ_THRESHOLD_STATE = "RESET_IAQ_THRESHOLD_STATE",
  // GET_IAQ_SENSOR_DATA_BY_ID_START='GET_IAQ_SENSOR_DATA_BY_ID_START',
  // GET_IAQ_SENSOR_DATA_BY_ID_SUCCESS='GET_IAQ_SENSOR_DATA_BY_ID_SUCCESS',
  // GET_IAQ_SENSOR_DATA_BY_ID_ERROR='GET_IAQ_SENSOR_DATA_BY_ID_ERROR',
  // RESET_GET_IAQ_SENSOR_DATA_BY_ID_STATE='RESET_GET_IAQ_SENSOR_DATA_BY_ID_STATE',
}

export default iaqRealtimeViewDataType;
